export {
  hasSelectedInbox,
  isInboxSelected,
  toggleInboxSelection,
} from './inboxSelection';

export const buildCannedResponseQuery = ({
  searchKey,
  conversationId,
}) => ({
  searchKey,
  conversationId,
});
